/* eslint-disable @angular-eslint/directive-selector */
import { Directive, Input, inject } from "@angular/core";
import { SelectorComponent } from "./selector.component";

@Directive({ selector: "rask-selector[bindValue]" })
export class SelectorValueBindingDirective {
    private readonly selectorComponent = inject(SelectorComponent);

    @Input()
    protected set bindValue(value: string) {
        const formatter = (item) => {
            if(!item) {
                return undefined;
            }
            return item[value];
        };

        this.selectorComponent.formatter = formatter;
    }
}
